import { createTypes } from 'reduxsauce';

export default createTypes(
    `
    SET_ORDERS
    ORDER_REQUEST
    ORDER_RESPONSE
`,
    {
        prefix: 'auctions/'
    }
);
